import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiModule } from '../shared/ui/ui.module';
import { WidgetModule } from '../shared/widget/widget.module';

import { PagesRoutingModule } from './pages-routing.module';

import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbNavModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgPipesModule } from 'ngx-pipes';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';

import { DashboardComponent } from './dashboard/dashboard.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { CustomersComponent } from './e-sign/customers/customers.component';
import { DocumentsComponent } from './e-sign/documents/documents.component';
import { PlansComponent } from './plans/plans.component';
import { SettingsComponent } from './settings/settings.component';
import { VendorsComponent } from './vendors/vendors.component';
import { EmailSttingsComponent } from './email-sttings/email-sttings.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { OrdersComponent } from './e-sign/orders/orders.component';
import { SharedModule } from '../shared/shared.module';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { DetailComponent } from './e-sign/customers/detail/detail.component';
import { AccessLogsComponent } from './access-logs/access-logs.component';
import { CronJobComponent } from './cron-job/cron-job.component';
import { ESignModule } from './e-sign/e-sign.module';
import { EstampModule } from './e-stamp/estamp.module';


@NgModule({
  declarations: [
    DashboardComponent,
    AnalyticsComponent,
    PlansComponent,
    SettingsComponent,
    VendorsComponent,
    EmailSttingsComponent,
    DetailComponent,
    AccessLogsComponent,
    CronJobComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    UiModule,
    NgPipesModule,
    CdkStepperModule,
    NgStepperModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    // SimplebarAngularModule,
    CKEditorModule,
    SharedModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    ESignModule,
    EstampModule
  ],
  providers: [
  ]
})
export class PagesModule { }
